import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
interface NewPromptModalProps {
  initialText: string;
  onClose: () => void;
  onSave: (text: string) => void;
  isEditing: boolean;
}
export function NewPromptModal({
  initialText,
  onClose,
  onSave,
  isEditing
}: NewPromptModalProps) {
  const [promptText, setPromptText] = useState(initialText);
  const [isTestingPrompt, setIsTestingPrompt] = useState(false);
  const [testResult, setTestResult] = useState<string | null>(null);
  const handleSave = () => {
    if (promptText.trim()) {
      onSave(promptText);
    }
  };
  const handleTestPrompt = () => {
    setIsTestingPrompt(true);
    // Simulate API call to test the prompt
    setTimeout(() => {
      setTestResult('Find Win Keep Analysis:\n\n' + 'FIND: The prospect currently uses manual processes and spreadsheets to track customer interactions. They struggle with visibility across teams and have no standardized approach.\n\n' + 'WIN: They need a solution that centralizes customer data, automates follow-ups, and provides analytics on customer engagement patterns.\n\n' + 'KEEP: To retain this customer, we should focus on ease of implementation, quick time-to-value, and ensuring their team adopts the platform through targeted training.');
      setIsTestingPrompt(false);
    }, 2000);
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-508">
      <div className="bg-[#1E2A38] rounded-lg w-full max-w-3xl max-h-[90vh] flex flex-col" data-id="element-509">
        <div className="flex justify-between items-center border-b border-[#F5F7FA] border-opacity-10 p-5" data-id="element-510">
          <h2 className="text-xl font-semibold text-[#F5F7FA]" data-id="element-511">
            {isEditing ? 'Edit Prompt' : 'Create New Prompt'}
          </h2>
          <button onClick={onClose} className="text-[#F5F7FA] text-opacity-70 hover:text-opacity-100" data-id="element-512">
            <XIcon className="w-6 h-6" data-id="element-513" />
          </button>
        </div>
        <div className="p-5 flex-grow overflow-auto" data-id="element-514">
          <div className="mb-5" data-id="element-515">
            <label htmlFor="prompt-text" className="block text-sm font-medium text-[#F5F7FA] mb-2" data-id="element-516">
              Prompt Text
            </label>
            <textarea id="prompt-text" rows={5} className="w-full bg-[#263445] border border-[#F5F7FA] border-opacity-10 rounded-md p-3 text-[#F5F7FA] placeholder-[#F5F7FA] placeholder-opacity-50 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:border-transparent" placeholder="Enter your custom prompt instructions here..." value={promptText} onChange={e => setPromptText(e.target.value)} data-id="element-517" />
            <p className="mt-2 text-sm text-[#F5F7FA] text-opacity-70" data-id="element-518">
              Write natural language instructions for how the brief generator
              should analyze information.
            </p>
          </div>
          {testResult && <div className="mt-6" data-id="element-519">
              <h3 className="text-md font-medium text-[#F5F7FA] mb-2" data-id="element-520">
                Test Result:
              </h3>
              <div className="bg-[#263445] rounded-md p-4 whitespace-pre-line" data-id="element-521">
                {testResult}
              </div>
            </div>}
        </div>
        <div className="border-t border-[#F5F7FA] border-opacity-10 p-5 flex justify-end space-x-4" data-id="element-522">
          <button onClick={onClose} className="px-4 py-2 border border-[#F5F7FA] border-opacity-30 rounded-md text-[#F5F7FA] hover:bg-[#263445] transition-colors" data-id="element-523">
            Cancel
          </button>
          <button onClick={handleTestPrompt} disabled={!promptText.trim() || isTestingPrompt} className={`px-4 py-2 border border-[#C8F169] rounded-md text-[#C8F169] hover:bg-[#C8F169] hover:bg-opacity-10 transition-colors ${!promptText.trim() || isTestingPrompt ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-524">
            {isTestingPrompt ? 'Testing...' : 'Test Prompt'}
          </button>
          <button onClick={handleSave} disabled={!promptText.trim()} className={`px-4 py-2 bg-[#C8F169] text-[#1A2331] rounded-md hover:bg-opacity-90 transition-colors ${!promptText.trim() ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-525">
            Save Prompt
          </button>
        </div>
      </div>
    </div>;
}